import React from 'react';
import { type SVGComponentProps } from '../../../../types/Svgs';

const SVGComponent: React.FC<SVGComponentProps> = ({ primaryColor, secondaryColor, size }) => {
  return (
    <div>
      <svg
        width={size != null ? size[0].toString() : '29'}
        height={size != null ? size[1].toString() : '38'}
        viewBox="0 0 29 38"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <style>
          {`
          .primaryDestination { fill: ${primaryColor != null ? primaryColor : '#FF7A00'} }
          .secondaryDestination { fill: ${secondaryColor != null ? secondaryColor : 'grey'} }
        `}
        </style>
        <path
          d="M15.4818 36.6238L15.59 36.5721L15.6767 36.4893C15.9505 36.2276 19.0412 33.2111 22.0694 28.9417C25.0779 24.7001 28.125 19.0842 28.125 13.6496V13.64L28.1248 13.6304C27.9442 6.55503 21.9077 0.818359 14.5646 0.818359C7.22608 0.818359 1.17383 6.555 1.17383 13.6496C1.17383 19.1243 4.22033 24.7398 7.22998 28.9728C10.2589 33.233 13.3502 36.2293 13.6222 36.4893C14.011 36.8609 14.4433 36.8598 14.6309 36.8593C14.6373 36.8593 14.6435 36.8593 14.6494 36.8593C14.9965 36.8593 15.3079 36.7082 15.4529 36.6378C15.4634 36.6327 15.4731 36.628 15.4818 36.6238ZM14.5646 19.0618C11.3833 19.0618 8.86696 16.6092 8.86696 13.6496C8.86696 10.69 11.3833 8.23734 14.5646 8.23734C17.7426 8.23734 20.2569 10.6848 20.2622 13.6402C20.1828 16.6205 17.6471 19.0618 14.5646 19.0618Z"
          className="primaryDestination"
          stroke="white"
          strokeWidth="1.5"
        />
        <circle cx="14.6493" cy="14.294" r="8.18074" fill="white" />
      </svg>
    </div>
  );
};

export default SVGComponent;
